<template>
  <div class="mf-card chart-container">
    <span v-if="!isPdf" class="pa-1 table-card-title">Faixa etária</span>
    <mf-loading :loader="['last-update', 'primeiro-registro', 'faixa']" :width="4" :height="70" loader-type="table">
      <v-container v-if="infoFaixa.length" fluid class="pa-0" fill-height>
        <v-layout align-start wrap>
          <v-flex xs12 md6>
            <data-card :infoFaixa="infoFaixa" :is-pdf="isPdf" />
          </v-flex>
          <v-flex xs12 md6>
            <chart :array="infoFaixa" label-property-name="NUM_FAIXA_ETARIA" data-property-name="NUM_CLIENTES_CADASTRADOS" />
          </v-flex>
        </v-layout>
      </v-container>
      <v-container v-else class="my-6">
        <v-row align="center">
          <v-col align="center">
            <span class="subtitle">Nenhum resultado encontrado</span>
          </v-col>
        </v-row>
      </v-container>
    </mf-loading>
  </div>
</template>

<script>
import orderBy from 'lodash/orderBy'
import DataCard from '@/modules/clientes/perfil-demografico/views/pages/FaixaEtariaDataTable.vue'
import Chart from '@/modules/clientes/perfil-demografico/views/pages/PerfilDemograficoChart.vue'
import { mapState } from 'vuex'

export default {
  components: {
    DataCard,
    Chart,
  },
  props: {
    isPdf: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      stateInfoFaixa: (state) => state.clientes.perfilDemograficoFaixa,
      stateFilters: (state) => state.filters,
    }),
    infoFaixa() {
      const totalCadastros = this.stateInfoFaixa.reduce((total, current) => total + current['NUM_CLIENTES_CADASTRADOS'], 0)
      const array = this.stateInfoFaixa.map((object) => {
        switch (object['NUM_FAIXA_ETARIA']) {
          case 0:
            object['NUM_FAIXA_ETARIA'] = 'Idade não cadastrada'
            object.ageRange = []
            break
          case 1:
            object['NUM_FAIXA_ETARIA'] = '18 a 24 anos'
            object.ageRange = [18, 24]
            break
          case 2:
            object['NUM_FAIXA_ETARIA'] = '25 a 34 anos'
            object.ageRange = [25, 34]
            break
          case 3:
            object['NUM_FAIXA_ETARIA'] = '35 a 44 anos'
            object.ageRange = [35, 44]
            break
          case 4:
            object['NUM_FAIXA_ETARIA'] = '45 a 54 anos'
            object.ageRange = [45, 54]
            break
          case 5:
            object['NUM_FAIXA_ETARIA'] = '55 a 64 anos'
            object.ageRange = [55, 64]
            break
          case 6:
            object['NUM_FAIXA_ETARIA'] = '65 anos ou mais'
            object.ageRange = [65, 99999]
            break
          case 7:
            object['NUM_FAIXA_ETARIA'] = '17 anos ou menos'
            object.ageRange = [0, 17]
            break
          case 8:
            object['NUM_FAIXA_ETARIA'] = 'Pessoa jurídica'
            object.ageRange = []
        }
        object['PORCENTAGEM'] = (object['NUM_CLIENTES_CADASTRADOS'] / totalCadastros) * 100
        return object
      })
      return orderBy(array, 'NUM_FAIXA_ETARIA')
    },
  },
}
</script>

<style lang="scss" scoped>
.chart-container {
  display: flex;
  flex-direction: column;
  padding: 16px;
  margin: 16px 0;
}
</style>
